import React, { useEffect } from 'react'
import loadComponent from 'src/utils/loadMFE'
import { DateTime } from 'luxon'
import { useStatisticParams } from './useStatisticParams'
import RouteContainer from 'src/components/App/RouteContainer'

const MarahFeedbacks = React.lazy(() => loadComponent('statistic', 'MarahFeedbacks'))

export function MarahFeedbacksRoute() {
    const [config, setConfig] = useStatisticParams()

    const isConfigInvalid = Object.values(config).some((value) => value === null || value === undefined)

    useEffect(() => {
        if (isConfigInvalid) {
            setConfig({
                from: DateTime.now().startOf('day').toJSDate(),
                to: DateTime.now().endOf('day').toJSDate(),
                chart: 'bar',
                breakdown: '',
                cumulation: '',
            })
        }
    }, [isConfigInvalid, setConfig])

    return (
        <>
            {!isConfigInvalid && (
                <RouteContainer>
                    <MarahFeedbacks config={config} onChangeConfig={setConfig} />
                </RouteContainer>
            )}
        </>
    )
}
